import React from "react";
import { Building, Hash, DollarSign, Tag } from "lucide-react";
import "./TakeoffCard.css";

const TakeoffCard = ({ takeoff, onClick }) => {
  const formatJobNumber = () => {
    return takeoff?.jobNumber || "N/A";
  };

  const formatPrice = (price) => {
    if (!price && price !== 0) return "TBD";
    return `$${price.toLocaleString()}`;
  };

  const getInvoiceStatusBadge = (status) => {
    if (!status || status === "") {
      return { text: "Not Set", className: "status-not-set" };
    }
    if (status === "Invoiced") {
      return { text: "Invoiced", className: "status-invoiced" };
    }
    if (status === "Paid") {
      return { text: "Paid", className: "status-paid" };
    }
    return { text: status, className: "status-default" };
  };

  const invoiceStatus = getInvoiceStatusBadge(takeoff?.invoicedStatus);

  return (
    <div className="takeoff-card" onClick={onClick}>
      <div className="takeoff-card-header">
        <h3 className="takeoff-card-title" title={takeoff?.projectName}>
          {takeoff?.projectName || "Unnamed Project"}
        </h3>
        <div className={`invoice-status-badge ${invoiceStatus.className}`}>
          {invoiceStatus.text}
        </div>
      </div>

      <div className="takeoff-card-body">
        <div className="takeoff-card-info">
          <Hash size={14} className="info-icon" />
          <span className="info-value">{formatJobNumber()}</span>
        </div>

        {takeoff?.formClient && (
          <div className="takeoff-card-info">
            <Building size={14} className="info-icon" />
            <span className="info-value" title={takeoff.formClient}>
              {takeoff.formClient}
            </span>
          </div>
        )}

        <div className="takeoff-card-info price">
          <DollarSign size={14} className="info-icon" />
          <span className="info-value">
            {formatPrice(takeoff?.abCivilPrice)}
          </span>
        </div>

        <div className="takeoff-card-info">
          <Tag size={14} className="info-icon" />
          <span className="info-value status-completed">
            {takeoff?.status || "Unknown"}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TakeoffCard;